














































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import DataTable from "@/components/elements/utility/Table.vue";
import { Mobile } from "@/mixins/mobile";
import { SalesOrderSummary } from "@/models/quote_draft/quote_draft";
import { formatSalesOrderDate } from "@/utility/helpers";

/**
 * FUPOF-200 — the Sales Orders table, shared by the global browse view
 * (SalesOrderList) and the Sales Orders tab on a customer's page
 * (CustomerOrders).
 *
 * Presentational: it renders rows and emits intent. Both parents bind the
 * emitted events straight to the OrderMixin methods that already exist —
 * `@reorder="requestSalesOrderAction"` and
 * `@download="downloadNetSuiteSalesOrder"` — so neither needs a wrapper. That
 * is why `download` emits the id and number as two arguments rather than the
 * row: it matches `downloadNetSuiteSalesOrder(id, number)`.
 *
 * Rows arrive already filtered. The `v-if` and the empty states stay with each
 * parent, whose copy differs ("No sales orders found." vs a customer-scoped
 * message) — the same split the quote tables already use.
 *
 * It takes the Mobile mixin rather than an `isMobile` prop so both parents get
 * the responsive label treatment for free.
 */
@Component({
  components: { DataTable }
})
export default class SalesOrderTable extends Mixins(Mobile) {
  /** Already-filtered rows; this component neither filters nor sorts. */
  @Prop({ required: true }) salesOrders!: SalesOrderSummary[];
  /** Hidden on a customer-scoped page, where the name is already the title. */
  @Prop({ default: true }) showCustomer!: boolean;

  protected formatDate = formatSalesOrderDate;
}
